/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_A2Inputs */

const en_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailor, cover letter, or interview prep uses 1 AI action. Job search, ATS scores, and salary data are always free.`)
};

const de_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Lebenslauf-Anpassung, jedes Anschreiben oder jede Interviewvorbereitung verbraucht 1 KI-Aktion. Jobsuche, ATS-Scores und Gehaltsdaten sind immer kostenlos.`)
};

const fr_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque adaptation de CV, lettre de motivation ou préparation d'entretien utilise 1 action IA. La recherche d'emploi, les scores ATS et les données salariales sont toujours gratuits.`)
};

const es_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada adaptación de currículum, carta de presentación o preparación de entrevista utiliza 1 acción de IA. La búsqueda de empleo, las puntuaciones ATS y los datos salariales son siempre gratuitos.`)
};

const it_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni adattamento del curriculum, lettera di presentazione o preparazione al colloquio utilizza 1 azione AI. La ricerca di lavoro, i punteggi ATS e i dati salariali sono sempre gratuiti.`)
};

const nl_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke cv-aanpassing, sollicitatiebrief of sollicitatievoorbereiding gebruikt 1 AI-actie. Vacaturezoeken, ATS-scores en salarisgegevens zijn altijd gratis.`)
};

const pl_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każde dopasowanie CV, list motywacyjny lub przygotowanie do rozmowy kwalifikacyjnej używa 1 akcji AI. Wyszukiwanie pracy, wyniki ATS i dane o wynagrodzeniach są zawsze bezpłatne.`)
};

const fi_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen ansioluettelon muokkaus, saatekirje tai haastatteluvalmistautuminen käyttää 1 tekoälytoiminnon. Työnhaku, ATS-pisteet ja palkkatiedot ovat aina ilmaisia.`)
};

const da_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvert CV-tilpasning, ansøgningsbrev eller interviewforberedelse bruger 1 AI-handling. Jobsøgning, ATS-scorer og løndata er altid gratis.`)
};

const sv_pricing_faq_a2 = /** @type {(inputs: Pricing_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje CV-anpassning, personligt brev eller intervjuförberedelse använder 1 AI-åtgärd. Jobbsökning, ATS-poäng och lönedata är alltid gratis.`)
};

/**
* | output |
* | --- |
* | "Each resume tailor, cover letter, or interview prep uses 1 AI action. Job search, ATS scores, and salary data are always free." |
*
* @param {Pricing_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_a2 = /** @type {((inputs?: Pricing_Faq_A2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_A2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_a2(inputs)
	if (locale === "fr") return fr_pricing_faq_a2(inputs)
	if (locale === "es") return es_pricing_faq_a2(inputs)
	if (locale === "it") return it_pricing_faq_a2(inputs)
	if (locale === "nl") return nl_pricing_faq_a2(inputs)
	if (locale === "pl") return pl_pricing_faq_a2(inputs)
	if (locale === "fi") return fi_pricing_faq_a2(inputs)
	if (locale === "da") return da_pricing_faq_a2(inputs)
	if (locale === "sv") return sv_pricing_faq_a2(inputs)
	return en_pricing_faq_a2(inputs)
});